import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useClientAuth } from '../context/ClientAuthContext';
import GifLoder from '../components/GifLoder';

const ProtectedRoute = ({ element: Component, allowedRoles }) => {
  const { isAuthenticated, role, loading } = useClientAuth();
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    // Ensure the loader is shown for at least 3 seconds
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, 1200);

    return () => clearTimeout(timer); // Clean up the timer
  }, []);

  if (loading || showLoader) {
    // Show a loading spinner or placeholder while checking authentication
    return (
      <div className="loderDiv">
        <GifLoder />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/Client" />;
  }

  // Check if the user's role is included in the allowedRoles array
  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/Client" />; // Redirect to home or an unauthorized page
  }

  // Ensure Component is a valid React component
  return <Component />;
};

export default ProtectedRoute;
